import React, { useState } from 'react';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Box, Button, Textarea, HStack, Badge } from '@chakra-ui/react';
import { EditIcon, CheckIcon, CloseIcon } from '@chakra-ui/icons';

const HtmlBlockView = ({ node, updateAttributes, editor }) => {
  const [editing, setEditing] = useState(!node.attrs.html);
  const [draft, setDraft] = useState(node.attrs.html || '');

  const apply = () => {
    updateAttributes({ html: draft });
    setEditing(false);
  };

  const cancel = () => {
    setDraft(node.attrs.html || '');
    setEditing(false);
  };

  if (editing && editor.isEditable) {
    return (
      <NodeViewWrapper className="wiki-html-block">
        <Box border="1px dashed" borderColor="purple.300" borderRadius="md" p={2} my={2}>
          <HStack justify="space-between" mb={2}>
            <Badge colorScheme="purple" fontSize="10px">HTML</Badge>
            <HStack>
              <Button size="xs" colorScheme="green" leftIcon={<CheckIcon />} onClick={apply}>Aplicar</Button>
              <Button size="xs" variant="ghost" leftIcon={<CloseIcon />} onClick={cancel}>Cancelar</Button>
            </HStack>
          </HStack>
          <Textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            fontFamily="monospace"
            fontSize="xs"
            rows={8}
            placeholder="<div>Cole ou escreva seu HTML aqui...</div>"
            bg="gray.50"
            _dark={{ bg: 'gray.900' }}
          />
        </Box>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper className="wiki-html-block">
      <Box position="relative" role="group" my={2} borderRadius="md" _hover={editor.isEditable ? { outline: '1px dashed', outlineColor: 'purple.300' } : undefined}>
        {editor.isEditable && (
          <HStack position="absolute" top={1} right={1} zIndex={2} opacity={0} _groupHover={{ opacity: 1 }} transition="opacity 0.2s">
            <Badge colorScheme="purple" fontSize="10px">HTML</Badge>
            <Button size="xs" leftIcon={<EditIcon />} onClick={() => { setDraft(node.attrs.html || ''); setEditing(true); }}>Editar</Button>
          </HStack>
        )}
        <div dangerouslySetInnerHTML={{ __html: node.attrs.html }} />
      </Box>
    </NodeViewWrapper>
  );
};

export const HtmlBlock = Node.create({
  name: 'htmlBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      html: { default: '' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="html-block"]',
        getAttrs: (el) => ({ html: el.innerHTML }),
      },
    ];
  },

  renderHTML({ node }) {
    const div = document.createElement('div');
    div.setAttribute('data-type', 'html-block');
    div.innerHTML = node.attrs.html || '';
    return div;
  },

  addNodeView() {
    return ReactNodeViewRenderer(HtmlBlockView);
  },

  addCommands() {
    return {
      insertHtmlBlock:
        () =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { html: '' } }),
    };
  },
});
